// material-ui

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = ({ style = {} }) => {
  return (
    <svg
      width="300"
      height="100"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
    >
      <g className="layer">
        <use
          fill="#d11f2e"
          id="svg_12"
          stroke="#7b6f67"
          stroke-opacity="0.06"
          transform="matrix(0.0422347 0 0 0.0435848 26.526 -2.64262)"
          x="-507.24"
          xlinkHref="#svg_11"
          y="188.3"
        />
        <path
          d="m38.64,13.06c0.42,-0.25 0.95,-0.46 1.62,-0.67c-2.03,-0.76 -2.6,-1.35 -3.27,-3.38c-0.78,2 -1.38,2.56 -3.45,3.22c2.04,0.76 2.6,1.35 3.28,3.38c0.3,-0.77 0.57,-1.33 0.91,-1.76c3.51,3.01 1.27,6.47 -7.79,8.04c-9.55,1.65 -23.92,2.09 -37.4,0.67c16.13,2.14 33.2,2.56 43.32,0.8c10.47,-1.81 10.89,-6.38 2.78,-10.3l0,0z"
          fill="#F8B333"
          id="svg_9"
        />
      </g>
      <defs>
        <symbol
          enable-background="new 0 0 122.88 92.02"
          height="800px"
          id="svg_11"
          version="1.1"
          viewBox="0 -15.43 122.88 122.88"
          width="800px"
          xmlSpace="preserve"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <style type="text/css">{`
  .st0{fill-rule:evenodd;clip-rule:evenodd;}
 `}</style>
          <g>
            <path
              className="st0"
              d="m10.17,34.23c-10.98,-5.58 -9.72,-11.8 1.31,-11.15l2.47,4.63l5.09,-15.83c2,-6.23 5.33,-11.88 11.86,-11.88l65.1,0c6.53,0 10.29,5.54 11.87,11.87l3.82,15.35l2.2,-4.14c11.34,-0.66 12.35,5.93 0.35,11.62l1.95,2.99c7.89,8.11 7.15,22.45 5.92,42.48l0,8.14c0,2.04 -1.67,3.71 -3.71,3.71l-15.83,0c-2.04,0 -3.71,-1.67 -3.71,-3.71l0,-4.54l-74.82,0l0,4.54c0,2.04 -1.67,3.71 -3.71,3.71l-15.83,0c-2.04,0 -3.71,-1.67 -3.71,-3.71l0,-10.11c0,-0.2 0.02,-0.39 0.04,-0.58c-1.2,-15.37 -2.89,-35.47 9.34,-43.39l0,0zm20.21,24.47l-14.06,-1.77c-3.32,-0.37 -4.21,1.03 -3.08,3.89l1.52,3.69c0.49,0.95 1.14,1.64 1.9,2.12c0.89,0.55 1.96,0.82 3.15,0.87l12.54,0.1c3.03,-0.01 4.34,-1.22 3.39,-4c-0.78,-2.61 -2.56,-4.25 -5.36,-4.9l0,0zm24,-5.91l14.4,0c0.85,0 1.55,0.7 1.55,1.55l0,0c0,0.85 -0.7,1.55 -1.55,1.55l-14.4,0c-0.85,0 -1.55,-0.7 -1.55,-1.55l0,0c-0.01,-0.85 0.69,-1.55 1.55,-1.55l0,0zm35.58,20.36l14.4,0c0.85,0 1.55,0.7 1.55,1.55l0,0c0,0.85 -0.7,1.55 -1.55,1.55l-14.4,0c-0.85,0 -1.55,-0.7 -1.55,-1.55l0,0c0,-0.85 0.69,-1.55 1.55,-1.55l0,0zm2.54,-14.45l14.06,-1.77c3.32,-0.37 4.21,1.03 3.08,3.89l-1.52,3.69c-0.49,0.95 -1.14,1.64 -1.9,2.12c-0.89,0.55 -1.96,0.82 -3.15,0.87l-12.54,0.1c-3.03,-0.01 -4.34,-1.22 -3.39,-4c0.78,-2.61 2.56,-4.25 5.36,-4.9l0,0zm-74.09,14.45l14.4,0c0.85,0 1.55,0.7 1.55,1.55l0,0c0,0.85 -0.7,1.55 -1.55,1.55l-14.4,0c-0.85,0 -1.55,-0.7 -1.55,-1.55l0,0c0,-0.85 0.7,-1.55 1.55,-1.55l0,0zm0.82,-41.95l86.82,0l-3.83,-15.92c-1.05,-4.85 -4.07,-9.05 -9.05,-9.05l-60.11,0c-4.97,0 -7.52,4.31 -9.05,9.05l-4.78,15.92l0,0.75l0,-0.75l0,0z"
            />
          </g>
        </symbol>
      </defs>
    </svg>
  );
};

export default LogoIcon;
